import { render } from "./InProgress.vue?vue&type=template&id=509bf802"
const script = {}
script.render = render

export default script